import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import endpoints from "../config/endpoints";
import { apiGet } from "../utils/api_service";
const initialState = {
  stockHolder: {},
};
let URL = endpoints.summaryDashboard;
const analyticalStockHolderSlice = createSlice({
  name: "stockHolderDashboard",
  initialState,
  reducers: {
    analyticalStockHolderSuccess: (state = cloneDeep(initialState), action) => {
      const { summaryData } = action.payload;
      return {
        ...state,
        stockHolder: summaryData,
      };
    },

    resetState: (state = cloneDeep(initialState), action) => {
      return {
        ...state,
        ...initialState,
      };
    },
  },
});

export const { analyticalStockHolderSuccess, resetState } =
  analyticalStockHolderSlice.actions;

export default analyticalStockHolderSlice.reducer;

export const getStockHolderSummary =
  ({ monthYear }) =>
  async (dispatch) => {
    try {
      const response = apiGet({
        url: URL + "/summary?monthYear=" + monthYear,
      }).then(({ data, success }) => {
        if (success) {
          const summaryObj = data.data;
          const summaryData = {
            outletCount:
              summaryObj.outletCount === null ? "" : summaryObj.outletCount,
            stockStakeHolderCount:
              summaryObj.stockStakeHolderCount === null
                ? ""
                : summaryObj.stockStakeHolderCount,
            salesTeamCount:
              summaryObj.salesTeamCount === null
                ? ""
                : summaryObj.salesTeamCount,
            vehicleCount:
              summaryObj.vehicleCount === null ? "" : summaryObj.vehicleCount,
            currentMonthSalesAmtPrimary:
              summaryObj.currentMonthSalesAmtPrimary === null
                ? ""
                : summaryObj.currentMonthSalesAmtPrimary,
            currentMonthOrderAmtPrimary:
              summaryObj.currentMonthOrderAmtPrimary === null
                ? ""
                : summaryObj.currentMonthOrderAmtPrimary,
            currentMonthSalesAmtSecondary:
              summaryObj.currentMonthSalesAmtSecondary === null
                ? ""
                : summaryObj.currentMonthSalesAmtSecondary,
            currentMonthOrderAmtSecondary:
              summaryObj.currentMonthOrderAmtSecondary === null
                ? ""
                : summaryObj.currentMonthOrderAmtSecondary,
            currentMonthGrnAmt:
              summaryObj.currentMonthGrnAmt === null
                ? ""
                : summaryObj.currentMonthGrnAmt,
            currentMonthCrnAmt:
              summaryObj.currentMonthCrnAmt === null
                ? ""
                : summaryObj.currentMonthCrnAmt,
            currentMonthSelfCrnAmt:
              summaryObj.currentMonthSelfCrnAmt === null
                ? ""
                : summaryObj.currentMonthSelfCrnAmt,
            currentMonthOutletCrnAmt:
              summaryObj.currentMonthOutletCrnAmt === null
                ? ""
                : summaryObj.currentMonthOutletCrnAmt,
            currentDateSalesAmtPrimary:
              summaryObj.currentDateSalesAmtPrimary === null
                ? ""
                : summaryObj.currentDateSalesAmtPrimary,
            currentDateOrderAmtPrimary:
              summaryObj.currentDateOrderAmtPrimary === null
                ? ""
                : summaryObj.currentDateOrderAmtPrimary,
            currentDateSalesAmtSecondary:
              summaryObj.currentDateSalesAmtSecondary === null
                ? ""
                : summaryObj.currentDateSalesAmtSecondary,
            currentDateOrderAmtSecondary:
              summaryObj.currentDateOrderAmtSecondary === null
                ? ""
                : summaryObj.currentDateOrderAmtSecondary,
            currentDateGrnAmt:
              summaryObj.currentDateGrnAmt === null
                ? ""
                : summaryObj.currentDateGrnAmt,
            currentDateCrnAmt:
              summaryObj.currentDateCrnAmt === null
                ? ""
                : summaryObj.currentDateCrnAmt,
            currentDateSelfCrnAmt:
              summaryObj.currentDateSelfCrnAmt === null
                ? ""
                : summaryObj.currentDateSelfCrnAmt,
            currentDateOutletCrnAmt:
              summaryObj.currentDateOutletCrnAmt === null
                ? ""
                : summaryObj.currentDateOutletCrnAmt,
          };
          dispatch(analyticalStockHolderSuccess({ summaryData }));
          return { response: summaryData, success };
        }
        return { response: {}, success };
      });
      return response;
    } catch (e) {
      return console.error(e.message);
    }
  };
